__turbopack_context__.v({
  "blok-big-title": "NeedleCartItem-module__XKkgaG__blok-big-title",
  "blok-subtitle": "NeedleCartItem-module__XKkgaG__blok-subtitle",
  "blok-title": "NeedleCartItem-module__XKkgaG__blok-title",
  "cart-image-wrapper": "NeedleCartItem-module__XKkgaG__cart-image-wrapper",
  "cart-item-container": "NeedleCartItem-module__XKkgaG__cart-item-container",
  "cart-item-detail": "NeedleCartItem-module__XKkgaG__cart-item-detail",
  "cart-item-details": "NeedleCartItem-module__XKkgaG__cart-item-details",
  "cart-item-image": "NeedleCartItem-module__XKkgaG__cart-item-image",
  "cart-item-info": "NeedleCartItem-module__XKkgaG__cart-item-info",
  "cart-item-lineprice": "NeedleCartItem-module__XKkgaG__cart-item-lineprice",
  "cart-item-name": "NeedleCartItem-module__XKkgaG__cart-item-name",
  "cart-item-price": "NeedleCartItem-module__XKkgaG__cart-item-price",
  "cart-item-summary": "NeedleCartItem-module__XKkgaG__cart-item-summary",
});
